import React from 'react';
import NavIcon from './NavIcon';
import styles from '../summary.module.scss';

const EmptyState = ({ message, icon }) => (
  <div className={styles.emptyState}>
    <div className={styles.emptyIcon}>
      <NavIcon type={icon || 'file'} size={28} />
    </div>
    <p>{message}</p>
  </div>
);

export default EmptyState;
